import { SxProps, Theme } from '@mui/material'

export const drawer: SxProps<Theme> = {
  '& .MuiDrawer-paper': {
    width: { xs: '100%', sm: 400 },
  },
}

export const drawerPaper: SxProps<Theme> = {
  padding: 3,
}

export const content: SxProps<Theme> = {
  display: 'flex',
  flexDirection: 'column',
  gap: 2,
  overflowY: 'auto',
  height: '100%',
}
